// src/services/calendarService.js
import axios from 'axios';

// ✅ Base API (usa IP si tu backend está en otro host; si no, déjalo relativo)
// Si tu frontend corre en :3001 y backend en :5000, esto está OK:
import API_BASE_URL from '../config/api';

const API_URL = API_BASE_URL;

// ✅ Axios instance
const api = axios.create({
  baseURL: API_URL,
  timeout: 30000,
});

// ✅ Headers con token
const getHeaders = () => {
  const token = localStorage.getItem('sessionToken') || localStorage.getItem('token');
  return {
    Authorization: token ? `Bearer ${token}` : undefined,
    'Content-Type': 'application/json',
  };
};

// ✅ Helper: normaliza start/end sin cambiar tu data original
const normalizeActivityForCalendar = (activity) => {
  const start = activity.start || activity.date || activity.createdAt;
  const base = start ? new Date(start) : null;

  // end: si viene, úsalo. Si no, 1 hora por defecto (no rompe FullCalendar)
  const end =
    activity.end ||
    (base ? new Date(base.getTime() + 60 * 60 * 1000).toISOString() : undefined);

  return {
    ...activity,
    start,
    end,
  };
};

/* ===================== CRUD Activities (mantiene lo que ya usas) ===================== */

// ✅ Agregar actividad
export const addActivity = async (activity) => {
  const { data } = await api.post('/api/activities/add', activity, {
    headers: getHeaders(),
  });
  return data;
};

// ✅ Obtener actividades “raw” por atleta (COMPATIBLE con tu useFetchEvents)
export const getActivities = async (start, end, athleteId) => {
  try {
    const { data } = await api.get(`/api/activities/athlete/${athleteId}`, {
      headers: getHeaders(),
      params: { start, end },
    });

    // backend puede devolver [] o {activities: []}. Soportamos ambos.
    const list = Array.isArray(data) ? data : (data?.activities || []);

    return list.map(normalizeActivityForCalendar);
  } catch (error) {
    console.error('❌ Error al obtener actividades:', error?.response?.data || error);
    return [];
  }
};

// ✅ Actualizar actividad
export const updateActivity = async (idActivity, activity) => {
  const { data } = await api.put(`/api/activities/update/${idActivity}`, activity, {
    headers: getHeaders(),
  });
  return data;
};

// ✅ Eliminar actividad
export const deleteActivity = async (id) => {
  const { data } = await api.delete(`/api/activities/delete/${id}`, {
    headers: getHeaders(),
  });
  return data;
};

// ✅ Obtener archivo .fit (si lo usas)
export const getFileActivity = async (idOwner, fileName) => {
  const payload = { idOwner, fileName };
  const { data } = await api.post('/api/activities/get-fitFile', payload, {
    headers: getHeaders(),
  });
  return data;
};

/* ===================== NUEVO (opcional): Calendario ===================== */

// ✅ Si tu backend tiene /api/calendar/activities?format=events, esto te devuelve eventos listos
export const getCalendarEvents = async ({ athleteId, start, end }) => {
  try {
    const { data } = await api.get('/api/calendar/activities', {
      headers: getHeaders(),
      params: { athleteId, start, end, format: 'events' },
    });

    const list = Array.isArray(data) ? data : (data?.events || []);

    // FullCalendar acepta Date o ISO; aquí entregamos ISO para evitar “Invalid Date”
    return list.map((e) => ({
      ...e,
      start: e.start,
      end: e.end,
    }));
  } catch (error) {
    console.error('❌ Error al obtener eventos calendario:', error?.response?.data || error);
    return [];
  }
};

// ✅ Mover actividad (si tu backend implementó /api/activities/move/:id)
export const moveActivity = async (id, { start, end }) => {
  const { data } = await api.put(`/api/activities/move/${id}`, { start, end }, {
    headers: getHeaders(),
  });
  return data;
};
